import { PaddingType } from 'common/types/styleTypes'
import { mobilePaddingsCss, paddingsCss } from 'common/utils/styleUtilsNew'
import styled from 'styled-components'

const BlogPostCardContentUi = styled.div<{
  padding?: PaddingType
  mobilePadding?: Partial<PaddingType>
}>`
  ${paddingsCss}
  ${p => p.theme.isEditorMobileMode && mobilePaddingsCss}
  ${p => p.theme.phone} {
    ${mobilePaddingsCss}
  }
`

export default BlogPostCardContentUi
